import { Outlet, Link } from "react-router-dom";
import Header from "@/components/Header";
import BottomNav from "@/components/BottomNav";
import MiniPlayer from "@/components/MiniPlayer";
import { Toaster } from "@/components/ui/sonner";
import { useAudio } from "@/context/AudioContext";
import LiveNotifier from "@/components/LiveNotifier";

const AppLayout = () => {
  const { current } = useAudio();
  const bottomPadding = current ? "pb-[144px]" : "pb-[84px]";

  return (
    <div className="min-h-screen flex flex-col bg-[var(--fi-bg)]">
      <Header />
      <main className={`flex-1 ${bottomPadding}`}>
        <Outlet />
        <footer className="max-w-6xl mx-auto px-4 md:px-6 pt-8 pb-2 text-center text-[11px] text-gray-400">
          © {new Date().getFullYear()} Fala Itapira e Região ·{" "}
          <Link to="/politica-de-privacidade" data-testid="footer-privacy-link" className="font-bold text-gray-500 hover:text-[var(--fi-blue)] underline-offset-2 hover:underline">
            Política de Privacidade
          </Link>
        </footer>
      </main>
      <MiniPlayer />
      <BottomNav />
      <LiveNotifier />
      <Toaster richColors position="top-center" />
    </div>
  );
};

export default AppLayout;
